import { ReactNode } from 'react'

type Props = {
    children: ReactNode
    hideShadow?: boolean
}

export const AstraGlassCard = ({ children, hideShadow }: Props) => (
    <div className={`w-full rounded-xl border bg-[#E8E8EC66] backdrop-blur-sm ${hideShadow ? '' : 'shadow-dialog'}`}>
        <div className="m-1 rounded-lg bg-surface-base shadow-md">{children}</div>
    </div>
)
